/* ============================================================
   META-TRAFFIC 1-PRODUCT THEME — theme.js
   Global behaviours that aren't tied to a single section:
   - Announcement bar rotation
   - Lazy `is-visible` reveal hooks
   - Anchor smooth-scroll
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Announcement bar rotator ---------- */
  document.querySelectorAll('[data-announcement]').forEach((root) => {
    const slides = root.querySelectorAll('[data-announcement-slide]');
    if (slides.length <= 1) return;
    const interval = parseInt(root.getAttribute('data-rotate-ms'), 10) || 4000;

    let i = 0;
    setInterval(() => {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, interval);
  });

  /* ---------- Smooth scroll for in-page anchors (e.g. "scroll to reviews") ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const id = a.getAttribute('href');
    if (id === '#' || id.length < 2) return;
    const target = document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    const headerOffset = 60;
    const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
    window.scrollTo({ top, behavior: 'smooth' });
  });

  /* ---------- IntersectionObserver-based reveal (opt-in via .reveal class) ---------- */
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach((el) => obs.observe(el));
  }

  /* ---------- Expose theme money settings for cart.js ---------- */
  window.theme = window.theme || {};
  window.theme.cart = window.theme.cart || {};
  // These get rewritten at section level if needed; here we read from data attributes.
  const mc = document.querySelector('[data-shipping-bar]');
  if (mc) {
    // Threshold is rendered into the Liquid template; cart.js falls back gracefully.
  }
})();
